/**
 * Configuration du store Redux avec Redux Toolkit
 */

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import etudiantReducer from './slices/etudiantSlice';
import noteReducer from './slices/noteSlice';
import releveReducer from './slices/releveSlice';
import uiReducer from './slices/uiSlice';
import openChatsReducer from './slices/openChatsSlice';
import { notesDevoirsApi } from '../services/notesDevoirsApi';
import { notesExamensApi } from '../services/notesExamensApi';
import { etudiantsApi } from '../services/etudiantsApi';
import { matieresApi } from '../services/matieresApi';
import { copiesApi } from '../services/copiesApi';
import { ocrApi } from '../services/ocrApi';
import { ocrApiV2 } from '../services/ocrApiV2';
import { rachatApi } from '../services/rachatApi';
import { anneeAcademiqueApi } from '../services/anneeAcademiqueApi';
import { polesOptionsApi } from '../services/polesOptionsApi';
import { coreApi } from '../services/coreApi';
import { uesApi } from '../services/uesApi';
import { reclamationsApi } from '../services/reclamationsApi';
import { relevesApi } from '../services/relevesApi';
import { resultatsApi } from '../services/resultatsApi';
import { pvDeliberationApi } from '../services/pvDeliberationApi';
import { brassageApi } from '../services/brassageApi';
import { formateursApi } from '../services/formateursApi';
import { emploisTempsApi } from '../services/emploisTempsApi';
import { fraudesApi } from '../services/fraudesApi';
import { sanctionsApi } from '../services/sanctionsApi';
import { enveloppesApi } from '../services/enveloppesApi';
import { messagerieApi } from '../services/messagerieApi';
import { messagesEtudiantsApi } from '../services/messagesEtudiantsApi';
import { demandesActivationApi } from '../services/demandesActivationApi';
import { rattrapageApi } from '../services/rattrapageApi';
import { portailAdminApi } from '../services/portailAdminApi';
import { messagesParentsApi } from '../services/messagesParentsApi';
import { suggestionsApi } from '../services/suggestionsApi';
import { formateurApi } from '../services/formateurApi';
import { vieScolaireApi } from '../services/vieScolaireApi';
import { inscriptionsParentsApi } from '../services/inscriptionsParentsApi';
import { formateurNotesApi } from '../services/formateurNotesApi';
import { parentsApi } from '../services/parentsApi';
import { auditCreditsApi } from '../services/auditCreditsApi';
import { messagerieChatApi } from '../services/messagerieChat';
import { bilanEtudiantApi } from '../services/bilanEtudiantApi';
import { suiviScolariteApi } from '../services/suiviScolariteApi';
import { comptesFormateursApi } from '../services/comptesFormateursApi';
import { serviceScolariteApi } from '../services/serviceScolariteApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    etudiants: etudiantReducer,
    notes: noteReducer,
    releves: releveReducer,
    ui: uiReducer,
    openChats: openChatsReducer,
    [notesDevoirsApi.reducerPath]: notesDevoirsApi.reducer,
    [notesExamensApi.reducerPath]: notesExamensApi.reducer,
    [etudiantsApi.reducerPath]: etudiantsApi.reducer,
    [matieresApi.reducerPath]: matieresApi.reducer,
    [copiesApi.reducerPath]: copiesApi.reducer,
    [ocrApi.reducerPath]: ocrApi.reducer,
    [ocrApiV2.reducerPath]: ocrApiV2.reducer,
    [rachatApi.reducerPath]: rachatApi.reducer,
    [anneeAcademiqueApi.reducerPath]: anneeAcademiqueApi.reducer,
    [polesOptionsApi.reducerPath]: polesOptionsApi.reducer,
    [coreApi.reducerPath]: coreApi.reducer,
    [uesApi.reducerPath]: uesApi.reducer,
    [reclamationsApi.reducerPath]: reclamationsApi.reducer,
    [relevesApi.reducerPath]: relevesApi.reducer,
    [resultatsApi.reducerPath]: resultatsApi.reducer,
    [pvDeliberationApi.reducerPath]: pvDeliberationApi.reducer,
    [brassageApi.reducerPath]: brassageApi.reducer,
    [formateursApi.reducerPath]: formateursApi.reducer,
    [emploisTempsApi.reducerPath]: emploisTempsApi.reducer,
    [fraudesApi.reducerPath]: fraudesApi.reducer,
    [sanctionsApi.reducerPath]: sanctionsApi.reducer,
    [enveloppesApi.reducerPath]: enveloppesApi.reducer,
    [messagerieApi.reducerPath]: messagerieApi.reducer,
    [messagesEtudiantsApi.reducerPath]: messagesEtudiantsApi.reducer,
    [demandesActivationApi.reducerPath]: demandesActivationApi.reducer,
    [rattrapageApi.reducerPath]: rattrapageApi.reducer,
    [portailAdminApi.reducerPath]: portailAdminApi.reducer,
    [messagesParentsApi.reducerPath]: messagesParentsApi.reducer,
    [suggestionsApi.reducerPath]: suggestionsApi.reducer,
    [formateurApi.reducerPath]: formateurApi.reducer,
    [vieScolaireApi.reducerPath]: vieScolaireApi.reducer,
    [inscriptionsParentsApi.reducerPath]: inscriptionsParentsApi.reducer,
    [formateurNotesApi.reducerPath]: formateurNotesApi.reducer,
    [parentsApi.reducerPath]: parentsApi.reducer,
    [auditCreditsApi.reducerPath]: auditCreditsApi.reducer,
    [messagerieChatApi.reducerPath]: messagerieChatApi.reducer,
    [bilanEtudiantApi.reducerPath]: bilanEtudiantApi.reducer,
    [suiviScolariteApi.reducerPath]: suiviScolariteApi.reducer,
    [comptesFormateursApi.reducerPath]: comptesFormateursApi.reducer,
    [serviceScolariteApi.reducerPath]: serviceScolariteApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(notesDevoirsApi.middleware)
      .concat(notesExamensApi.middleware)
      .concat(etudiantsApi.middleware)
      .concat(matieresApi.middleware)
      .concat(copiesApi.middleware)
      .concat(ocrApi.middleware)
      .concat(ocrApiV2.middleware)
      .concat(rachatApi.middleware)
      .concat(anneeAcademiqueApi.middleware)
      .concat(polesOptionsApi.middleware)
      .concat(coreApi.middleware)
      .concat(uesApi.middleware)
      .concat(reclamationsApi.middleware)
      .concat(relevesApi.middleware)
      .concat(resultatsApi.middleware)
      .concat(pvDeliberationApi.middleware)
      .concat(brassageApi.middleware)
      .concat(formateursApi.middleware)
      .concat(emploisTempsApi.middleware)
      .concat(fraudesApi.middleware)
      .concat(sanctionsApi.middleware)
      .concat(enveloppesApi.middleware)
      .concat(messagerieApi.middleware)
      .concat(messagesEtudiantsApi.middleware)
      .concat(demandesActivationApi.middleware)
      .concat(rattrapageApi.middleware)
      .concat(portailAdminApi.middleware)
      .concat(messagesParentsApi.middleware)
      .concat(suggestionsApi.middleware)
      .concat(formateurApi.middleware)
      .concat(vieScolaireApi.middleware)
      .concat(inscriptionsParentsApi.middleware)
      .concat(formateurNotesApi.middleware)
      .concat(parentsApi.middleware)
      .concat(auditCreditsApi.middleware)
      .concat(messagerieChatApi.middleware)
      .concat(bilanEtudiantApi.middleware)
      .concat(suiviScolariteApi.middleware)
      .concat(comptesFormateursApi.middleware)
      .concat(serviceScolariteApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
